import i18n from 'modules/core/lib/i18n'

import type JobLevel from 'modules/job_catalog/store/models/JobLevel'

export type JobLevelWarningType = 'archived'
export interface JobLevelWarning {
  type: JobLevelWarningType
  warning: string
}

export const getLevelWarning = (level: JobLevel | undefined): JobLevelWarning | null => {
  if (!level) {
    return null
  }

  if (level.isArchived) {
    return {
      type: 'archived',
      warning: i18n.t('job_catalog.job_level_archived'),
    }
  }

  return null
}
